var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitboi2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 601.831,
    height: 650.236,
    viewBox: "0 0 601.831 650.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3.849,
    y1: 0.5,
    x2: 4.849,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c251c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "#60271e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#722f27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.232,
    y1: 0.476,
    x2: 0.37,
    y2: 0.403,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#302624",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#302624",
    stopOpacity: 0.361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#302624",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.477,
    y1: 0.157,
    x2: 0.534,
    y2: 0.798,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.623,
    y1: 0.178,
    x2: 1.386,
    y2: 1.011,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfd4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#cfd4d8",
    stopOpacity: 0.631
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#cfd4d8",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#cfd4d8",
    stopOpacity: 0.082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfd4d8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.999, 0.045, 0.045, 0.999, -747.061, 17.004)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f69d7d",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#f69d7d",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#f69d7d",
    stopOpacity: 0.443
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#f69d7d",
    stopOpacity: 0.149
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69d7d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-0.999, 0.045, 0.045, 0.999, -756.11, 17.21)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -669.629,
    y1: 0.601,
    x2: -668.927,
    y2: 0.404,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f69d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#f69d7d",
    stopOpacity: 0.929
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#f69d7d",
    stopOpacity: 0.745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69d7d",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.547,
    y1: 1.176,
    x2: 0.484,
    y2: 0.309,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8e8d8",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#f8e8d8",
    stopOpacity: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8e8d8",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(-169.195 -1161.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(169.195 1161.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(463.669 179.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M690.54,399.879s5.955-10.317,11.12-14.057,13.4-2.995,19.81-10.041,16.382-.1,16.561-13.457-5.7-9.775,1.068-16.105-3.913-12.793-3.913-12.793,8.9-8.321,5.517-15.436-15.713-6.936-39.724,2.5c0,0-13.335-6.953-16.781-2.5s-.242,44.334-.242,44.334l-13.531,24.7Z",
    transform: "translate(-670.424 -221.411)",
    fill: "#fbc0a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M677.423,326.018c.548-2,2.048-3.56,3.5-5.038l6.532-6.659c7.369-1.679,12.707-1.737,16.238-.335a254.493,254.493,0,0,1-24.063,17.2C677.666,330.536,676.875,328.009,677.423,326.018Z",
    transform: "translate(-637.844 -221.406)",
    fill: "#f69d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M675.719,314.292c12.308,10.745,20.906,24.663,17.675,28s-17.675-7.184-17.675-7.184l1.622,12.014s14.692,7.975,19.631-3.433S675.719,314.292,675.719,314.292Z",
    transform: "translate(-645.165 -215.214)",
    fill: "#f69d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M677.259,402.207a1.123,1.123,0,0,0-.468-.283l96.06-104.8,5.361,6.3L679.18,404.354A25.1,25.1,0,0,0,677.259,402.207Z",
    transform: "translate(-640.051 -297.122)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M577.708,342.734l11.771-25.22s32.774,15.129,40.342,25.22l-13.45,23.017Z",
    transform: "translate(-129.47 6.927)",
    fill: "#f8e8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M559.537,312.861s17.121,6.494,26.2,28.28c8.4,20.168,29.273,131.961,29.273,131.961l71.444-119.354,48.753,29.415S651.156,553.419,626.779,564.951s-55.757-32.237-55.757-32.237l-6.29-169.338Z",
    transform: "translate(-234.856 -24.85)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M559.537,312.861s17.121,6.494,26.2,28.28c8.4,20.168,29.273,131.961,29.273,131.961l71.444-119.354,48.753,29.415S651.156,553.419,626.779,564.951s-55.757-32.237-55.757-32.237l-6.29-169.338Z",
    transform: "translate(-234.856 -24.85)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M573.35,380.97s9.805-.537,14.014-5.691-9.573-47.38-9.573-47.38,13.1-11.315,13.293-27.192-10.322-24.064-26.689-23.064-39.968,22.765-39.968,22.765l11.995,6.181s3.869,36,8.99,45.259S573.35,380.97,573.35,380.97Z",
    transform: "translate(-426.285 -211.052)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M526.989,288.835c4.8,22.486,20.684,78.012,20.684,78.012l14.13-16.109-7.092-69.4Z",
    transform: "translate(-411.736 -189.164)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M746.846,411.865c-42.287,14.653-138,36.507-215.882,4.563-.116-20.011.177-46.55.115-60.605L743.323,374.27C744.288,386.577,745.5,394.784,746.846,411.865Z",
    transform: "translate(-391.588 217.35)",
    fill: "#302624"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(150.337 530.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M724.61,359.317c-1.646-6.031-2.978-9.826-2.978-9.826l-187.384,7.691s-.66,3.828-1.687,10.369c.925,1.285,1.687,2.251,1.687,2.251C617.863,403.936,678.427,403.97,724.61,359.317Z",
    transform: "translate(-532.561 -349.491)",
    fill: "#330e00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M526.743,347.027l32.843,120.68L542.892,580.452s148.348,56.383,241.442-4.365l-19.12-251.954Z",
    transform: "translate(-415.346 33.565)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(84.751 257.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M758.85,326.89c7.439,3.135,58,16.918,30,83.031l-8.534,178.218s9.519,27.464,3.515,33.291c-46.2,44.81-106.809,44.81-190.526,10.635,0,0-4.406-5.617-4.978-7.874-3.067-12.11,7.16-45.918,7.16-45.918L548.7,432.815s-46.122-62.767-15.584-85.533C581.155,311.469,680.172,293.769,758.85,326.89Z",
    transform: "translate(-522.668 -309.341)",
    fill: "#3e3533"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M555.157,314.921c-29.565,32.761-36.29,183.713-36.29,183.713l53.554,16.55,14.13-137.625Z",
    transform: "translate(-455.551 -11.558)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M789.078,570.728l-11.1-146.22a288.83,288.83,0,0,0-50.419,85.6,356.637,356.637,0,0,1-125.1-108.393q18.3,48.917,36.6,97.826c-31.639-37.119-81.5-137.366-113.133-174.486l38.4,137.291L547.636,575.094S695.984,631.476,789.078,570.728Z",
    transform: "translate(-419.921 38.924)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M646.57,308.874s18.461-.8,21.813,1.272,11.75,26.321,13.443,30.149-22.446,26.389-22.446,26.389S679.3,399.371,678.46,402s-36.14,145.526-36.14,145.526-85.6-127.677-87.348-134.028,8.2-39.186,8.2-39.186-25.349-18.685-26.893-22.758-4.78-30.116,0-33.42c2.938-2.033,19.977-5.868,19.977-5.868Z",
    transform: "translate(-374.89 -46.557)",
    fill: "#302624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M537.083,318.475h-.007s26.24,67.711,49.345,127.33c18.182,46.9,38.255-2.155,38.255-2.155l5.664-134.443c-1.258-.088-3.883-.422-5.134-.49Z",
    transform: "translate(-355.76 -44.044)",
    fill: "#f8e8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M619.97,352.146c5.249-1.244,5.494-17.693,5.494-17.693l1.047-24.887c-.054-.122-.108-.252-.163-.374-1.312-.1-3.754-.415-4.95-.476l-81.215,9c.292.965-2.965,7.738-2.38,9.635,4.706,13.851,19.868,33.767,22.908,34.25,3.57.571,12.648-9.832,13.871-13.232,1.87,1.68,5.066,6.718,6.929,8.4.993,24.207.115,56.063-.272,85.492,14.069,36.3,27.2,70.172,32.856,84.785,1.027,1.36,2.06,2.645,3.094,3.883l3.025-71.934q-13.738-51.956-27.477-103.905c2.91-3.978,6.67-6.943,9.581-10.927C607.173,348.883,613.191,352.14,619.97,352.146Z",
    transform: "translate(-352.037 -46)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(162.016 183.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M622.031,395.871c-7.881,4.549-24.159,6.922-33.006,7.14-13.144.36-7.86-7.337-12.246-8.5l-42.641-98.459,77.135,34.766.177,3.271Z",
    transform: "translate(-534.138 -296.052)",
    fill: "#fbc0a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(162.067 184.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M600.836,365.238a77.382,77.382,0,0,1-23.684-6.908,160.659,160.659,0,0,1-21.031-11.512l-21.983-50.766,77.135,34.766.177,3.271,5.59,32.645C611.641,366.2,606.228,365.871,600.836,365.238Z",
    transform: "translate(-534.138 -296.052)",
    fill: "#f69d7d"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M593.834,429.753l-27.457-92.672L578.385,323.6l-20.4-12.484L542.394,325.5l14.517,12.858a860.575,860.575,0,0,0-1.332,93.55c18.182,46.9,34.42,88.81,34.42,88.81Z",
    transform: "translate(-325.495 -32.572)",
    fill: "#ac5fb5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(176.876 251.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M552.766,309.269s31.013,29.694,38.969,28.4,12.1-31.224,12.1-31.224,28.32,8.146,31.788,12.1-5,42.722-8.738,44.606c-7.84,3.957-31.462-22.418-35.766-19.053s-16.469,25.886-20.488,25.438S534.686,337.576,536.488,326,552.766,309.269,552.766,309.269Z",
    transform: "translate(-536.414 -306.447)",
    fill: "#f8e8d8"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M549.928,364.019s-26.641-6.079-22.949,25.73S553.7,422.184,560.5,423.557c0,0,12.675,56.641,82.548,51.215s58.409-59.524,57.9-95.4S704.437,281.2,658.7,276.61C612.567,271.98,545.876,275.012,549.928,364.019Z",
    transform: "translate(-414.874 -224.19)",
    fill: "#fbc0a4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(210.284 184.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M574.373,302.261c.286.537-1.252,2.108-4.474,3.42a22.393,22.393,0,0,1-5.909,1.435,26.3,26.3,0,0,1-14.551-2.686,22.283,22.283,0,0,1-5.011-3.454c-2.625-2.448-3.366-4.345-2.965-4.794.463-.523,2.3.707,4.923,2.054a43.04,43.04,0,0,0,4.828,2.183,41.807,41.807,0,0,0,6.174,1.713,40.8,40.8,0,0,0,6.372.6,43.1,43.1,0,0,0,5.289-.306C572.075,302.064,574.06,301.636,574.373,302.261Z",
    transform: "translate(-541.361 -296.059)",
    fill: "#f6876e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(190.176 141.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M562.772,296.573c-.945.952-5.678-2.652-12.328-2.319a22.159,22.159,0,0,0-8.044,2.074c-1.02.456-1.89.891-2.522,1.136-.666.265-1.163.367-1.4.136s-.238-.714.062-1.421a8.68,8.68,0,0,1,1.931-2.6,15.214,15.214,0,0,1,9.9-4.086,16.935,16.935,0,0,1,3.06.19,15.079,15.079,0,0,1,2.8.714,13.968,13.968,0,0,1,4.216,2.339C562.574,294.492,563.213,296.144,562.772,296.573Z",
    transform: "translate(-538.307 -289.479)",
    fill: "#3e3533"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(244.382 139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M568.159,295.006c-.911.959-5.358-2.047-11.164-1.108a18.158,18.158,0,0,0-6.786,2.727c-.843.53-1.564,1.04-2.108,1.333-.564.333-1.02.5-1.3.313s-.38-.626-.252-1.326a7.5,7.5,0,0,1,1.3-2.72,12.977,12.977,0,0,1,8.568-5.052,14.426,14.426,0,0,1,2.849-.109,13.479,13.479,0,0,1,2.659.449,12.114,12.114,0,0,1,4.032,1.945C568,293.014,568.595,294.564,568.159,295.006Z",
    transform: "translate(-546.497 -289.035)",
    fill: "#3e3533"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(228.681 147.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M549.832,327.134c-.062-.673,2.23-1.285,3.433-4.256a8.611,8.611,0,0,0,.435-5.317,32.44,32.44,0,0,0-2.652-7.051c-4.882-10.594-7.867-19.637-6.677-20.182s6.12,7.588,11,18.189a26.736,26.736,0,0,1,2.672,8.445,12.3,12.3,0,0,1-.279,4.243,10.094,10.094,0,0,1-1.6,3.386,7.082,7.082,0,0,1-4.379,2.992C550.512,327.78,549.846,327.433,549.832,327.134Z",
    transform: "translate(-544.111 -290.301)",
    fill: "#f69d7d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(180.591 121.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M571.468,293.4c-.395.571-2.373-.217-5.481-1.047a31.989,31.989,0,0,0-23.833,2.278c-1.455.728-2.631,1.319-3.474,1.741-.877.415-1.476.585-1.707.34s-.088-.829.442-1.693a14.34,14.34,0,0,1,2.883-3.2,24.412,24.412,0,0,1,26.981-2.584C570.454,291.044,571.828,292.9,571.468,293.4Z",
    transform: "translate(-536.872 -286.325)",
    fill: "#3e3533"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(240.378 121.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M546.02,296.049c-.449-.421.543-2.5,3.318-4.882a24.37,24.37,0,0,1,26.974-2.591,14.578,14.578,0,0,1,3.441,2.584c.68.755.925,1.305.754,1.584s-.8.231-1.741-.014c-.9-.252-2.176-.605-3.74-1.047a32.031,32.031,0,0,0-23.833,2.292C548.3,295.376,546.509,296.532,546.02,296.049Z",
    transform: "translate(-545.916 -285.666)",
    fill: "#3e3533"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M571.976,311.315a18.742,18.742,0,1,1-19.577-17.87A18.745,18.745,0,0,1,571.976,311.315Z",
    transform: "translate(-369.559 -126.003)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M584.442,310.748a18.742,18.742,0,1,1-19.576-17.869A18.748,18.748,0,0,1,584.442,310.748Z",
    transform: "translate(-299.619 -129.138)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M528.716,296.481c-2.435,8.418,1.02,17.292,4.413,25.369,1.006,2.4,2.121,4.93,4.27,6.4s5.657,1.244,6.786-1.1c1.094-2.264-.524-4.821-1.782-7s-1.972-5.453.143-6.813c.986-.632,2.278-.578,3.318-1.129,2.251-1.19,2.237-4.406,1.653-6.895a38.5,38.5,0,0,0-3.787-9.846c-1.673-3.033-4.318-6.133-7.779-6.072C532.333,289.45,529.722,293,528.716,296.481Z",
    transform: "translate(-406.546 -148.348)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(127.276 76.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M537.212,342.42s10.954,8.058,13.967,25.873h8.051V337.517s24.376-6.7,15.129-42.518-45.537-.238-45.537-.238Z",
    transform: "translate(-528.821 -279.02)",
    fill: "#3e3533"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M617.965,351.1a61.224,61.224,0,0,1-58.62,4.005c-32.611-14.762-32.455-36.575-32.455-36.575s28.531-1.136,47.9-22.623,75.8-43.3,118.361-13.769,29.184,72.852,3.679,80.168-39.934-10.39-46.38-6.48S633.829,363.956,617.965,351.1Z",
    transform: "translate(-413.627 -267.78)",
    fill: "#3e3533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M712.956,280.049a70.571,70.571,0,0,0-9.357-9.431,292.4,292.4,0,0,1-167.312,46.455,44.062,44.062,0,0,0,3.909,5.215,102.905,102.905,0,0,0-14,8.683,199.06,199.06,0,0,0,186.759-50.922Z",
    transform: "translate(-417.389 -251.319)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M516.8,344.676a5.556,5.556,0,0,0-3.577-.007c-2.8,1.217-2.523,5.249-1.666,8.18a135.606,135.606,0,0,0,10.2,25.145,18.3,18.3,0,0,0-4.957-33.318Z",
    transform: "translate(-501.362 155.76)",
    fill: "#e58c7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M711.421,577.511l-35.316-252.9-166.55,22.51,45.351,251.836Z",
    transform: "translate(-509.556 36.322)",
    fill: "#cf68a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M668.179,325.218,510.412,348.6l44.28,241.721L700.14,567.309Z",
    transform: "translate(-504.588 39.859)",
    fill: "#ae63b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M654.6,325.744l-143,27.093L548.08,581.82l136.337-24.453Z",
    transform: "translate(-497.668 42.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M523.9,429.35c-9.805-5.059-8.568-25.92-9.676-35.249q-1.153-9.649-2.3-19.3c-.761-6.433-1.373-13.531,2.353-18.835,2.421-3.454,6.33-5.555,10.281-7.024,3.053-1.135,6.371-1.972,9.553-1.271s6.133,3.339,6.235,6.6c.1,3.3-2.591,6.283-2.21,9.567.626,5.406,8.819,7.425,9.37,12.845.455,4.508-4.726,7.616-5.793,12.022-1.238,5.093,3.237,9.642,4.767,14.653,2.958,9.7-4.951,25.036-14.864,26.845A11.78,11.78,0,0,1,523.9,429.35Z",
    transform: "translate(-499.144 168.6)",
    fill: "#ffbd9b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    transform: "translate(200.655 1584.505) rotate(-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 112.625,
    height: 5.608,
    fill: "#a361b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 112.625,
    height: 5.608,
    transform: "translate(0 17.236)",
    fill: "#a361b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 112.625,
    height: 5.608,
    transform: "translate(0 34.471)",
    fill: "#a361b4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitboi2);
export default __webpack_public_path__ + "static/media/Suitboi2.135cdc17a24046ca310b116bed01620c.svg";
export { ForwardRef as ReactComponent };